import { render, staticRenderFns } from "./TravelFuture.vue?vue&type=template&id=5ec3ab42&"
import script from "./TravelFuture.vue?vue&type=script&lang=js&"
export * from "./TravelFuture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports